import SelectLanguage from './select-language';

export default SelectLanguage;
